<div class="options-step">
  <div class="row">
    <div class="col-12">
      <!-- Loading suggestions -->
      <div class="mb-4 text-center py-5" *ngIf="suggestionsLoading">
        <div class="mb-3">
          <img src="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl-ai-2.png" alt="Rubbl AI" class="ai-logo-loading" />
        </div>
        <h5 class="mb-2 d-flex align-items-center justify-content-center">
          <common-spinner-loader class="mr-2"></common-spinner-loader>Getting option suggestions
        </h5>
        <p class="text-muted font-weight-light">This usually takes a few seconds...</p>
      </div>

      <!-- Main content -->
      <div *ngIf="!suggestionsLoading && machine && !machineLoading">
        <!-- Option suggestions -->
        <div *ngIf="optionCheckboxCards.length > 0" class="form-section mb-4">
          <div class="mb-3 text-center">
            <img src="https://company.rubbl.com/pubweb/marketplace/images/icons/rubbl-ai-2.png" alt="Rubbl AI" class="ai-logo-loading mb-2" />
            <p class="text-muted small mb-0">Suggested by Rubbl AI</p>
          </div>
          <h5 class="section-header mb-3">Which options does your machine have?</h5>
          <p class="fs-15 font-weight-light">
            We have suggested the most common options for this machine. Listing options increases the likelihood of renting out your machine.
          </p>

          <div class="row">
            <div class="col-md-4 mb-3" *ngFor="let card of optionCheckboxCards">
              <common-checkbox-cards [checkboxCards]="[card]" (checkboxCardsChange)="onSingleOptionCheckboxChange(card.value, $event)"> </common-checkbox-cards>
            </div>
          </div>
        </div>

        <!-- No suggestions fallback -->
        <div *ngIf="optionCheckboxCards.length === 0" class="text-center py-4">
          <i class="icon-settings fs-48 text-muted mb-3"></i>
          <p class="text-muted">No option suggestions available for this machine type.</p>
        </div>

        <!-- Navigation Buttons -->
        <div class="text-center">
          <button type="button" class="btn btn-success btn-lg" (click)="onNext()" [disabled]="loading">
            <span *ngIf="loading" class="spinner-border spinner-border-sm mr-2"></span>
            {{ loading ? "Generating description..." : "Continue to Attachments" }}
          </button>

          <div class="mt-3">
            <button type="button" class="btn btn-link text-success" (click)="onBack()" [disabled]="loading">
              <i class="icon-arrow-left mr-1"></i>
              Back to Pricing
            </button>
          </div>
        </div>

        <!-- Validation Messages -->
        <div class="alert alert-danger mt-3" *ngIf="validationErrors.length > 0">
          <ul class="mb-0">
            <li *ngFor="let error of validationErrors">{{ error }}</li>
          </ul>
        </div>
      </div>

      <!-- Loading state -->
      <div *ngIf="machineLoading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="text-muted mt-3">Loading machine details...</p>
      </div>
    </div>
  </div>
</div>
